











































import { Component, Prop, Mixins } from "vue-property-decorator";

import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import AppContent from "@/components/AppContent/AppContent.vue";
import ActivityBox from "@/components/ActivityBox/ActivityBox.vue";
import Alert from "@/components/BaseAlert/BaseAlert.vue";
import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";

import RequestState from "@/utils/mixins/RequestState";
import { ILesson, IActivity } from "@/models/interfaces/lessons";
import { IVuexState } from "@/models/interfaces/store";

@Component({
  components: {
    AppHeader,
    AppHeaderBackWithTitle,
    AppContent,
    ActivityBox,
    Alert,
    BaseSpinner
  }
})
export default class LessonsStep21View extends Mixins(RequestState) {
  @Prop({ required: true })
  private lessonData!: IVuexState<{
    activities: IActivity[];
    lesson: ILesson;
  }>;

  @Prop({ default: "", type: String })
  private title!: string;

  private get sortedActivities() {
    return this.lessonData.data!.activities.sort((a, b) =>
      a.order > b.order ? 1 : -1
    );
  }
}
